import de from './translations/de.json';
import en from './translations/en.json';

export default {
  de,
  en,
};
